// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__KH-AP","author":"Table_author__gNIDx","authorImage":"Table_authorImage__2aeXT","unreadRow":"Table_unreadRow__2cveP"};